import { CandidateWorkflow } from "@/components/hr/CandidateWorkflow";

export default function CandidateWorkflowPage() {
  return <CandidateWorkflow />;
}